import CreateCategory from './CreateCategory';
export default CreateCategory;